import { advantages } from '@/mocks/faq';

export default function AdvantagesSection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900">
              hth 核心优势
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
              六大核心优势，为您提供全方位的品质服务体验
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {advantages.map((item) => (
              <div
                key={item.title}
                className="group p-6 md:p-8 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-md bg-primary-50 text-primary-500 group-hover:bg-primary-100 transition-colors">
                  <i className={`${item.icon} text-xl`}></i>
                </div>
                <h3 className="mt-4 text-base md:text-lg font-heading font-semibold text-foreground-900">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-500 leading-relaxed">
                  {item.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}